import { DataHandlerFolder, DataHandlerMedia, FileSystem } from "luxedo-data"

export const FileSystemMedia = new FileSystem({
	file: DataHandlerMedia,
	folder: DataHandlerFolder,
})
